module.exports = __webpack_public_path__ + "static/media/dynamics_parts_052123.8f8c5996.png";